import React from 'react';

export const IconEdit = ({ width = 16, height = 24, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 16 24" fill="none" stroke="currentColor" {...props}>
    <path d="M11.5 1.5l3 3L5.5 13.5l-4 1 1-4L11.5 1.5z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 3l3 3" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M0.5 18.5 Q1.5 15.5 3 18.5 Q4.5 21.5 6 18.5 Q7.5 15.5 9 18.5 Q10.5 21.5 12 18.5" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
  </svg>
);

export const IconTrash = ({ width = 16, height = 24, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 16 24" fill="none" stroke="currentColor" {...props}>
    <path d="M2 5h12M5 5V3a2 2 0 012-2h2a2 2 0 012 2v2M6 10v7M10 10v7M3 5v14a2 2 0 002 2h6a2 2 0 002-2V5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const IconInfo = ({ width = 16, height = 16, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

export const IconDetails = ({ width = 16, height = 16, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="currentColor" {...props}>
    <path d="M3 2h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"
      fill="none" stroke="currentColor" strokeWidth="1.5"/>
    <line x1="5" y1="5" x2="11" y2="5" stroke="currentColor" strokeWidth="1.5"/>
    <line x1="5" y1="8" x2="11" y2="8" stroke="currentColor" strokeWidth="1.5"/>
    <line x1="5" y1="11" x2="9" y2="11" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
);

export const IconPdfDownload = ({ width = 16, height = 16, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="currentColor" {...props}>
    <path d="M8 1v9M4 7l4 4 4-4" fill="none" stroke="currentColor"
      strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 13h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const IconSpinner = ({ width = 16, height = 16, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="currentColor"
    style={{animation: 'spin 1s linear infinite'}} {...props}>
    <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor"
      strokeWidth="2" strokeDasharray="20 10"/>
  </svg>
);

